<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path
        d="M731.5 948.4v-2.5l64.3-81.5H576.9v-72.8H919v43l-90 113.8h-97.5zM107.7 837.3v-112c0-36.8 5.2-64.9 16.5-88.4l5.5-10.1 4.7-6.8c44.4-58.7 151.8-95.7 294.9-101.4l19.7-.6 23.5-.3 22.5.3c39.1.8 75.9 3.8 109.5 8.9l-55.2 67.6c-11.9-1-24.4-1.8-37.9-2.3l-17.6-.5-21.5-.3-22.2.3c-78.1 1.6-142.8 12.3-192.2 31.7-25.9 10.2-48.2 23.3-59.5 35.1l-.1.1-3.2 3.7-2.6 3.6-.1.2c-5.9 10.1-9.4 27-10.2 48.9l-.2 10v112.3h-74.3zm469.2-123.6v-43.1l90-113.8h97.5v2.4L700 640.8h219v72.9H576.9zM471.1 487.3c-46.6 0-90.5-18.1-123.6-51.1-33.1-32.9-51.3-76.8-51.5-123.5V253c.1-46.7 18.4-90.5 51.5-123.5 32.2-32.1 74.6-50.1 119.9-51.1h4.3c96.9 0 175.7 78.3 175.7 174.5v59.8c-.1 46.7-18.4 90.5-51.5 123.5-33.1 32.9-76.9 51.1-123.6 51.1h-1.2zm.6-335.1c-55.9 0-101.3 45.2-101.3 100.7v59.8c0 55.6 45.5 100.8 101.3 100.8 55.9 0 101.4-45.2 101.4-100.7V253c0-55.6-45.5-100.8-101.4-100.8z"
        data-follow-fill="#231815"
        :fill="_fill"
      />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
